$(".abc").click(function () {
	alert("This is an alert message! 123");
});
// Show the first tab and hide the rest
$('#formatabs-nav li:first-child').addClass('active');
$('.formatabs-content').hide();
$('.formatabs-content:first').show();

// Click function
$('#formatabs-nav li').click(function(){
	$('#formatabs-nav li').removeClass('active');
	$(this).addClass('active');
	$('.formatabs-content').hide();

	var activeTab = $(this).find('a').attr('href');
	$(activeTab).fadeIn();
	return false;
});

$('.navigation-sub-collection .icon-li[href^="#"]').on('click',function (e) {
	e.preventDefault();

	var target = this.hash;
	var $target = $(target);
	var scroll;
	
	if (window.matchMedia("(max-width: 767px)").matches)  
	{ 
		
		// The viewport is less than 768 pixels wide 
		if($(window).scrollTop()==0){
			scroll =  ($target.offset().top) - 190
		}else{
			scroll =  ($target.offset().top) - 190
		}
	} else { 
		
		// The viewport is at least 768 pixels wide 
		if($(window).scrollTop()==0){
			scroll =  ($target.offset().top) - 270
		}else{
			scroll =  ($target.offset().top) - 270
		}
	} 			
	
	$('html, body').stop().animate({
		'scrollTop': scroll
	}, 900 , function () {
		//window.location.hash = target;
	});
});
$('#fade').cycle({ 
			delay: -4000 
		});